/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const deletePipeSeriesPipeseriesidPathPipeSeriesIdSchema = z.string()

export const deletePipeSeriesPipeseriesidStatus204Schema = z.string()

export const deletePipeSeriesPipeseriesidStatus400Schema = z.string()

export const deletePipeSeriesPipeseriesidStatus401Schema = z.string()

export const deletePipeSeriesPipeseriesidStatus404Schema = z.string()

export const deletePipeSeriesPipeseriesidStatus500Schema = z.string()

export const deletePipeSeriesPipeseriesidResponseSchema = deletePipeSeriesPipeseriesidStatus204Schema

export const deletePipeSeriesPipeseriesidErrorSchema = z.union([deletePipeSeriesPipeseriesidStatus400Schema, deletePipeSeriesPipeseriesidStatus401Schema, deletePipeSeriesPipeseriesidStatus404Schema, deletePipeSeriesPipeseriesidStatus500Schema])

export const deletePipeSeriesPipeseriesidPathSchema = z.object({
  pipeSeriesId: z.string(),
})
